import { IsNotAuthenticated } from "@/components/authWrappers.component";
import type { RouteObject } from "react-router-dom";
import { Outlet } from "react-router-dom";
import LoginPage from "./pages/Login.page";
import ChangePasswordPage from "./pages/ChangePassword.page";

// This is an example of how to lazy load the pages
// const Login = lazy(() => import('../pages/Login'));
// const Register = lazy(() => import('../pages/Register'));

export const authRoutes: RouteObject[] = [
	{
		element: <Outlet />,
		children: [
			{
				path: "login",
				element: (
					<IsNotAuthenticated>
						<LoginPage />
					</IsNotAuthenticated>
				),
			},
			{
				path: "change-password/:token",
				element: (
					<IsNotAuthenticated>
						<ChangePasswordPage />
					</IsNotAuthenticated>
				),
			},
		],
	},
];
